import React, { useEffect, useState } from 'react'
import FeaturedStlistCardImage1 from '../../../assets/imgs/featured-stylist-card-image-1.png'
import StarIcon from '../../../assets/imgs/star-icon.svg'
import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined'
import StarGradientIcon from '../../../assets/imgs/profile-screen-images/star-icon-performance.png'
import AchievementIcon from '../../../assets/imgs/profile-screen-images/achievements.png'
import UserImagePlaceholder from '../../../assets/imgs/user-image-placeholder.png'
import Swal from 'sweetalert2'
import { saveOrUpdateDataById } from '../../../apis/generalApis'
import { Link } from 'react-router-dom'
import { ScaleLoader } from 'react-spinners'
import { Avatar } from '@mui/material'

const FeaturedStylistCard = ({
  stylist,
  userType = '',
  component = '',
  action = '',
  isFavourite = false,
  getFavouriteStylists,
  getProfileReviews,
  getFeaturedStylists,
  getClientPastStylists,
  getStylists,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [isLoading, setIsLoading] = useState(false)
  const handleIsFavourite = async () => {
    try {
      let body = {
        user_id: user?.id,
        stylist_id: stylist?.id,
      }
      let result
      setIsLoading(true)
      if (action === 'add-favourite') {
        result = await saveOrUpdateDataById('add-favorite-stylist', body)
      } else if (action === 'remove-favourite') {
        result = await saveOrUpdateDataById('remove-favorite-stylist', body)
      }
      setIsLoading(false)
      if (result?.success === true) {
        if (getFavouriteStylists) {
          getFavouriteStylists()
        }
        if (getProfileReviews) {
          getProfileReviews()
        }
        if (getFeaturedStylists) {
          getFeaturedStylists()
        }
        if (getClientPastStylists) {
          getClientPastStylists()
        }
        if (getStylists) {
          getStylists()
        }
        Swal.fire({
          icon: 'success',
          title: result?.message,
          timer: 3000,
          confirmButtonColor: '#2597F6',
        })
      }
    } catch (error) {
      console.error(error)
    }
  }

  // const [isFavourite, setIsFavourite] = React.useState(false)
  return (
    <div className="featured-stylist-card">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100vh',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div
        className="position-relative styler-card"
        style={{ borderTopRightRadius: '20px', borderTopLeftRadius: '20px' }}
      >
        <div className="px-3 py-2 d-flex gap-1 align-items-center">
          <Link
            to={`/stylist-profile/${stylist?.id}`}
            className="text-decoration-none text-black pointer"
          >
            {stylist?.profile_image && (
              <Avatar
                src={stylist?.profile_image}
                sx={{ width: 65, height: 65 }}
              />
            )}
            {!stylist?.profile_image && (
              <Avatar
                src={UserImagePlaceholder}
                sx={{ width: 65, height: 65 }}
              />
            )}
          </Link>
          <div className="w-100">
            <p className="fs-24 font-weight-bold text-left text-capitalize">
              {(stylist?.first_name ?? '') + ' ' + (stylist?.last_name ?? '')}
            </p>
            <div className="d-flex justify-content-between align-items-center">
              <p className="d-flex align-items-center gap-1">
                <span className="fs-18" style={{ lineHeight: 'initial' }}>
                  {stylist?.avg_rating != null
                    ? Number.parseFloat(stylist?.avg_rating).toFixed(1)
                    : 'Not Rated'}
                </span>{' '}
                <img src={StarIcon} alt="" height={18} />
              </p>
              {userType !== 'client' && (
                <span onClick={handleIsFavourite}>
                  {isFavourite ? (
                    <FavoriteIcon
                      className="pointer"
                      sx={{ color: '#08C4BB', fontSize: '30px' }}
                    />
                  ) : (
                    <FavoriteBorderOutlinedIcon
                      className="pointer"
                      sx={{ color: '#08C4BB', fontSize: '30px' }}
                    />
                  )}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <hr
        className="mx-3 my-auto"
        style={{ opacity: 1, border: '1px solid #08C4BB' }}
      />
      <div className="stylist-card-about-me text-center pb-1">
        <p className="fs-24 text-decoration-underline font-weight-bold mt-1">
          About me
        </p>
        {/* <p className="fs-24 w-75 m-auto my-1">{stylist?.about}</p> */}
        <p
          className="fs-24 w-75 m-auto my-1"
          style={{ wordBreak: 'break-all', opacity: '80%' }}
        >
          {stylist?.about?.slice(0, 131)}
        </p>
      </div>
      {user?.user_type === 'client' && (
        <div className="styler-card-footer">
          <hr
            className="mx-3 my-auto"
            style={{ opacity: 1, border: '1px solid #08C4BB' }}
          />
          <div className="d-flex justify-content-between my-2 px-3">
            <div className="text-left">
              <p className="d-flex align-items-center">
                <img src={StarGradientIcon} alt="Star Icon" height={21} />
                <span className="fs-18">{`${
                  stylist?.reviews_count ?? 0
                } Reviews`}</span>
              </p>
              <p className="d-flex align-items-center mt-1">
                <img src={AchievementIcon} alt="Star Icon" height={21} />
                <span className="fs-18">{`${
                  stylist?.completed_jobs ?? 0
                } Completed Styles`}</span>
              </p>
            </div>
            <div className="text-right">
              <p className="fs-12">Starting At</p>
              <p
                className="fs-36 font-weight-bold color-primary"
                style={{ lineHeight: 'normal' }}
              >{`$${
                stylist?.avg_price && stylist?.avg_price > 0
                  ? stylist?.avg_price?.toFixed(2)
                  : 0
              }`}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default FeaturedStylistCard
